import { BlockStoreStats } from '#block-store/types';
import { getPrintIndentation } from '#common/stats';
export class CryptoStats extends BlockStoreStats {
    static STATS_NAME = 'CryptoStats';
    totalBlocksEncrypted = 0;
    totalBytesEncrypted = 0;
    totalEncryptFailures = 0;
    totalBlocksDecrypted = 0;
    totalBytesDecrypted = 0;
    totalDecryptFailures = 0;
    constructor(log) {
        super(CryptoStats.STATS_NAME, log);
    }
    toString(indentLevel) {
        let result = super.toString(indentLevel);
        const indentation = getPrintIndentation(indentLevel);
        result += '\n' + indentation;
        result += `totalBlocksEncrypted=${this.totalBlocksEncrypted.toFixed()}`;
        result += '\n' + indentation;
        result += `totalBytesEncrypted=${this.totalBytesEncrypted.toFixed()}`;
        result += '\n' + indentation;
        result += `totalEncryptFailures=${this.totalEncryptFailures.toFixed()}`;
        result += '\n' + indentation;
        result += `totalBlocksDecrypted=${this.totalBlocksDecrypted.toFixed()}`;
        result += '\n' + indentation;
        result += `totalBytesDecrypted=${this.totalBytesDecrypted.toFixed()}`;
        result += '\n' + indentation;
        result += `totalDecryptFailures=${this.totalDecryptFailures.toFixed()}`;
        return result;
    }
}
